export class MasterFilterSession {
    locationid: string;
    policestation: string;    
}

export class PoliceStnFilterSession {
    policestationname: string;
}

